<template>
    <div class="board" v-if="formData">
        <div class="bar">
            <b-icon icon="card-text" class="icon"></b-icon>
            <span>ข้อมูลลูกค้าเครดิต</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="text-center" v-if="isShowButtonLookup">
                <button class="btn btn-red" @click="openLookupCustomerFleet()">ค้นหาลูกค้าฟลีต</button>
            </div>

            <div class="form" v-if="isShowCustomerInfo">
                <div class="dashed-line mt-4 mb-4" v-if="isShowButtonLookup"></div>

                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>ชื่อบริษัท</label>
                            <input type="text" class="input-field" v-model="formData.fleet.company" readonly />
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เลขประจำตัวผู้เสียภาษี</label>
                            <input type="text" class="input-field" v-model="formData.fleet.taxId" readonly />
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เบอร์ติดต่อ</label>
                            <input type="text" class="input-field" v-model="formData.fleet.contactTel" readonly />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="field">
                            <label>ที่อยู่ร้านค้า</label>
                            <input type="text" class="input-field" v-model="formData.fleet.address" readonly />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <job-modal-fleet-lookup :isDisplay="isShowLookupCustomerFleet" @hide="closeLookupCustomerFleet($event)"></job-modal-fleet-lookup>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import JobModalFleetLookup from '@/components/job/order/ModalFleetLookup';

export default {
    mixins: [ MixinThemeBoard ],
    components: {
        JobModalFleetLookup
    },
    data() {
        return {
            isShowButtonLookup: true,
            isShowLookupCustomerFleet: false,
            isShowCustomerInfo: false,
            formData: null
        }
    },
    props: {
        jobState: Number,
        loadData: Object
    },
    mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);

            if (this.loadData) {
                if (this.loadData.status !== this.$Constants.JOB_STATUS_NEW) {
                    this.initPendingDisplay();
                }
            }
        },
        initForm() {
            return {
                fleet: {
                    fleetKey: this.loadData ? this.loadData.fleet.fleetKey : '',
                    company: this.loadData ? this.loadData.fleet.company : '',
                    taxId: this.loadData ? this.loadData.fleet.taxId : '',
                    contactTel: this.loadData ? this.loadData.fleet.contactTel : '',
                    address: this.loadData ? this.loadData.fleet.address : ''
                },
            };
        },
        initPendingDisplay() {
            this.isShowButtonLookup = false;
            this.isShowCustomerInfo = true;

            this.$emit('customerReady');
        },
        openLookupCustomerFleet() {
            this.isShowLookupCustomerFleet = true;
        },
        closeLookupCustomerFleet(data) {
            if (data) {
                this.formData.fleet.fleetKey = data.key;
                this.formData.fleet.company = data.company;
                this.formData.fleet.taxId = data.taxId;
                this.formData.fleet.contactTel = data.contactTel;
                this.formData.fleet.address = data.address;
                
                this.isShowCustomerInfo = true;
                
                this.$emit('customerReady');
            }

            this.isShowLookupCustomerFleet = false;
        }
    }
}
</script>